var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .008h27.44v32.415H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.13.155h27.298v32.416H.13z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.16 23.522c0 8.83-7.207 15.987-16.096 15.987-8.89 0-16.096-7.158-16.096-15.987 0-8.83 7.206-15.987 16.096-15.987S40.16 14.693 40.16 23.522",
    fill: "#359EAD"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.668 9.37)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.396 32.423C8.252 32.423 0 24.227 0 14.153 0 8.652 2.46 3.496 6.751.008l.728.884c-4.022 3.27-6.33 8.103-6.33 13.26 0 9.445 7.737 17.13 17.247 17.13 2.974 0 5.906-.765 8.479-2.21l.566.994a18.498 18.498 0 0 1-9.045 2.357",
    fill: "#2D2D2E",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.032 5.096)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m20.677 32.57-.729-.883c4.023-3.27 6.33-8.104 6.33-13.261 0-9.445-7.736-17.129-17.246-17.129-2.92 0-5.806.738-8.344 2.135L.13 2.433A18.506 18.506 0 0 1 9.032.155c10.144 0 18.396 8.196 18.396 18.27 0 5.501-2.461 10.657-6.751 14.146",
    fill: "#2D2D2E",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D2E",
    d: "M13.716 12.674h-1.15V9.819H9.692V8.677h4.024zM38.435 38.367h-4.024V34.37h1.15v2.855h2.874z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.01 23.522c0 8.198-6.691 14.845-14.946 14.845-8.255 0-14.946-6.647-14.946-14.845 0-8.199 6.691-14.845 14.946-14.845 8.255 0 14.946 6.646 14.946 14.845",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.064 12.674c-.634 0-1.15-.512-1.15-1.142 0-.63.516-1.142 1.15-1.142.634 0 1.15.512 1.15 1.142 0 .63-.516 1.142-1.15 1.142zM24.064 36.654c-.634 0-1.15-.512-1.15-1.142 0-.63.516-1.142 1.15-1.142.634 0 1.15.512 1.15 1.142 0 .63-.516 1.142-1.15 1.142zM36.136 24.664c-.634 0-1.15-.512-1.15-1.142 0-.63.516-1.142 1.15-1.142.634 0 1.15.512 1.15 1.142 0 .63-.516 1.142-1.15 1.142M11.992 24.664c-.635 0-1.15-.512-1.15-1.142 0-.63.515-1.142 1.15-1.142.634 0 1.15.512 1.15 1.142 0 .63-.516 1.142-1.15 1.142M32.686 16.1c-.294 0-.589-.112-.813-.334a1.139 1.139 0 0 1 0-1.615 1.157 1.157 0 0 1 1.626 0c.448.445.448 1.17 0 1.615a1.151 1.151 0 0 1-.813.333M15.44 33.228c-.294 0-.589-.111-.813-.334a1.138 1.138 0 0 1 0-1.615 1.158 1.158 0 0 1 1.626 0c.448.445.448 1.17 0 1.615a1.15 1.15 0 0 1-.813.334M32.687 33.228c-.294 0-.589-.111-.813-.334a1.138 1.138 0 0 1 0-1.615 1.158 1.158 0 0 1 1.626 0c.449.445.449 1.17 0 1.615a1.15 1.15 0 0 1-.813.334M15.44 16.098a1.15 1.15 0 0 1-.812-.333 1.138 1.138 0 0 1 0-1.615 1.157 1.157 0 0 1 1.625 0c.448.445.448 1.17 0 1.614a1.15 1.15 0 0 1-.813.334",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D2E",
    d: "m29.981 30.206-6.492-6.448v-8.8h1.15v8.328l6.155 6.112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.214 23.522c0 .63-.515 1.142-1.15 1.142-.635 0-1.15-.511-1.15-1.142 0-.631.515-1.142 1.15-1.142.635 0 1.15.511 1.15 1.142",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.064 22.951a.573.573 0 0 0-.575.57.574.574 0 0 0 1.15 0 .573.573 0 0 0-.575-.57m0 2.284a1.72 1.72 0 0 1-1.725-1.713 1.72 1.72 0 0 1 1.725-1.713 1.72 1.72 0 0 1 1.724 1.713 1.72 1.72 0 0 1-1.724 1.713",
    fill: "#2D2D2E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.e6160ffe2000ad56eedb76f63a19401d.svg";
export { ForwardRef as ReactComponent };